import BackgroundWrapper     from "_components/atoms/backgroundWrapper";
import Image                 from "_components/atoms/image";
import Loader                from "_components/atoms/loader";
import Typography            from "_components/atoms/typography";
import CustomDateRangePicker from "_components/pages/growthDashboard/datePicker";
import GrowthPageTab         from "_components/pages/growthDashboard/tabs";
import useStyles             from "_styles/pages/growthDashboard";

const Dashboard = ( {
	// changeData,
	endDate,
	handleChangeUser,
	// isLoading,
	average,
	// data,
	prodDate,
	secondaryUserId,
	secondaryData,
	secondaryProfile,
	secondaryLoading,
	setEndDate,
	setStartDate,
	setTabVal,
	setUserLink,
	startDate,
	tabVal,
	userLink,
	testDate,
	todaysDate,
	userProfile
} ) => {

	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<BackgroundWrapper
			className = { classes.growthPageRoot }
			type      = "secondary"
		>

			<div className = { classes.growthPageHeader }>
				{
					userProfile?.communityTeamUser
						? (

							<form className = { classes.communityPageContainer }
								onSubmit       = { e => handleChangeUser ( e, startDate, endDate, secondaryUserId ) }
							>
								<input className = { classes.communityPageInput }
									onChange        = { e => setUserLink ( e.target.value ) }
									placeholder     = "Enter the user profile link..."
									type            = "text"
									value           = { userLink }
								/>

								<button className = { classes.communityPageBtn }
									// onClick = { () => handleChangeUser ( startDate, endDate, secondaryUserId ) }
									type             = "submit"
								>
									Search
								</button>
							</form>

						)
						: null
				}

				<div className = { classes.dateSelector }>
					<CustomDateRangePicker
						customDate    = { startDate }
						customMaxDate = { endDate }
						label         = "Start Date"
						prodDate      = { prodDate }
						setCustomDate = { setStartDate }
						testDate      = { testDate }
						todaysDate    = { todaysDate }
					/>
				</div>

				<div className = { classes.dateSelector }>
					<CustomDateRangePicker
						isEndDatePicker
						customDate    = { endDate }
						customMinDate = { startDate }
						label         = "End Date"
						prodDate      = { prodDate }
						setCustomDate = { setEndDate }
						testDate      = { testDate }
						todaysDate    = { todaysDate }
					/>
				</div>
			</div>

			{
				secondaryLoading ?
					<Loader size = { "md" } /> :
					(
						<div className = { classes.secondaryDataContainer }>

							<Typography className = { classes.secondaryName }
								title                = { "Showing data for:" }
							/>

							<Image alt = "secondary_profile_image"
								className = { classes.secondaryImg }
								src       = { secondaryProfile ? secondaryProfile?.photo : userProfile?.photo }
								width     = "40px"
							/>

							<Typography className = { classes.secondaryName }
								title                = { secondaryProfile ? secondaryProfile?.name : userProfile?.name }
							/>

						</div>
					)
			}

			{
				average && (
					<Typography
						className = { classes.secondaryName }
						style     = { {
							display        : "flex",
							margin         : "4rem",
							fontWeight     : "500",
							fontSize       : "1.6rem",
							justifyContent : "center"
						} }
						title     = { `Average : ${ average.toFixed ( 2 ) }` }
					/>
				)
			}

			<GrowthPageTab
				// data      = { !changeData ? data : secondaryData }
				data        = { secondaryData }
				isLoading   = { secondaryLoading }
				setTabVal   = { setTabVal }
				tabVal      = { tabVal }
				userProfile = { userProfile }
			/>
		</BackgroundWrapper>
	);
};

export default Dashboard;
